import React from "react";
import AppIcon from "./AppIcon";

export const ORDER_INACTIVITY_OPTIONS = [
  { key: "5", label: "تا 5 روز" },
  { key: "7", label: "تا 7 روز" },
  { key: "10", label: "تا 10 روز" },
  { key: "15", label: "تا 15 روز" },
  { key: "more_15", label: "بیشتر از 15 روز" },
];

export const OrderInactivityIntroModal = ({ onContinue, onClose }) => {
  return (
    <div className="order-inactivity-intro">
      <div className="order-inactivity-intro-icon">
        <AppIcon name="calendar" width={40} height={40} alt="" />
      </div>
      <h2>مرتب‌سازی بر اساس ثبت سفارش</h2>
      <p>مشتریان خود را بر اساس میزان زمانی که ثبت سفارش نکرده‌اند مرتب‌سازی کنید.</p>
      <button type="button" className="order-inactivity-intro-btn" onClick={onContinue}>
        ادامه
      </button>
      <button type="button" className="order-inactivity-intro-close" onClick={onClose}>
        بستن
      </button>
    </div>
  );
};

const OrderInactivityFilterModal = ({ activeFilter, onSelect, onClose }) => {
  return (
    <div className="sort-modal order-inactivity-modal">
      <div className="sort-modal-head">
        <h2>
          <AppIcon name="calendar" width={22} height={22} alt="" />
          فیلتر بدون سفارش
        </h2>
        <button type="button" className="sort-modal-close" onClick={onClose} aria-label="بستن">
          ×
        </button>
      </div>
      <p className="order-inactivity-modal-desc">
        مشتریانی که در بازه انتخابی برایشان سفارش ثبت نشده نمایش داده می‌شوند.
      </p>
      <div className="sort-modal-options">
        {ORDER_INACTIVITY_OPTIONS.map((option) => (
          <button
            key={option.key}
            type="button"
            className={`sort-modal-option ${activeFilter === option.key ? "active order-inactivity-active" : ""}`}
            onClick={() => onSelect(option.key)}
          >
            {option.label}
          </button>
        ))}
        <button
          type="button"
          className="sort-modal-option order-inactivity-reset"
          onClick={() => onSelect("reset")}
        >
          بازنشانی تنظیمات
        </button>
      </div>
    </div>
  );
};

export default OrderInactivityFilterModal;
